import React from 'react';
import { Box, Typography, Divider, Tooltip, IconButton } from '@mui/material';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import MarkEmailUnreadIcon from '@mui/icons-material/MarkEmailUnread';

const EmailView = ({ selectedEmail, handleToggleReadStatus, formatDate, getTimeRemaining }) => {
  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {selectedEmail.subject || '(No Subject)'}
        </Typography>
        {selectedEmail.is_read !== undefined && (
          <Tooltip title={selectedEmail.is_read ? "Mark as unread" : "Mark as read"}>
            <IconButton onClick={handleToggleReadStatus} color="primary">
              {selectedEmail.is_read ? <MarkEmailUnreadIcon /> : <MarkEmailReadIcon />}
            </IconButton>
          </Tooltip>
        )}
      </Box>
      <Box sx={{ p: 2 }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
          <strong>From:</strong> {selectedEmail.from}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
          <strong>To:</strong> {selectedEmail.to}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          <strong>Received:</strong> {formatDate(selectedEmail.received_at)}
        </Typography>
        {selectedEmail.expires_at && (
          <Typography
            variant="caption"
            color={getTimeRemaining(selectedEmail.expires_at).includes('Expired') ? 'error.main' : 'text.secondary'}
            sx={{ mb: 2, display: 'block' }}
          >
            {getTimeRemaining(selectedEmail.expires_at)}
          </Typography>
        )}
      </Box>
      <Divider />
      <Box sx={{ flexGrow: 1, p: 2, overflowY: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word', bgcolor: 'action.hover' }}>
        {selectedEmail.body || '(No content)'}
      </Box>
    </Box>
  );
};

export default EmailView;
